<div class="home-scroll-wrapper">
  <app-community-header
    [community]="community"
    [communityStats]="communityStats">
  </app-community-header>

  <app-create-post
    [profilePhoto]="profilePhoto"
    (postCreated)="loadInitialPosts()"
    [IsRecruiter]="IsRecruiter">
  </app-create-post>

  <div class="feed-container">
    <app-feed
      [isLoading]="loadingPosts && cursor === null"
      [communityID]="communityID"
      (postCreated)="loadInitialPosts()"
      [isRecruiter]="IsRecruiter">
    </app-feed>

    <div *ngIf="loadingPosts && cursor !== null" class="text-center py-3">
      <div class="spinner-border text-secondary" role="status">
        <span class="visually-hidden">Loading more...</span>
      </div>
    </div>

    <div
      *ngIf="!loadingPosts && !hasMore && cursor !== null"
      class="text-center text-muted py-3">
      <i class="bi bi-check-circle me-1"></i>
      You've reached the end of the feed.
    </div>
  </div>
</div>
